import { useState } from "react";
import { ShieldCheck, KeyRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import api from "@/lib/api";

const PIN_RE = /^\d{6,8}$/;

export function ChangePinForm({ storeName, currentPin, onDone }) {
  const [pin1, setPin1] = useState("");
  const [pin2, setPin2] = useState("");
  const [busy, setBusy] = useState(false);
  const valid = PIN_RE.test(pin1);
  const match = pin1 === pin2 && valid;

  const submit = async () => {
    if (!valid) return toast.error("Il nuovo PIN deve avere da 6 a 8 cifre");
    if (!match) return toast.error("I due PIN non coincidono");
    setBusy(true);
    try {
      await api.storeChangePin(currentPin, pin1);
      toast.success("PIN aggiornato: usalo dal prossimo accesso");
      onDone();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Cambio PIN non riuscito");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-4" data-testid="change-pin-form">
      <div className="rounded-lg bg-amber-500/10 border border-amber-500/30 p-3 text-sm">
        <p className="font-semibold flex items-center gap-1.5 text-amber-300"><ShieldCheck className="h-4 w-4" /> Nuovo PIN richiesto</p>
        <p className="text-muted-foreground text-xs mt-1">Per sicurezza i PIN delle sedi passano a <b>6-8 cifre</b>. Scegli ora il nuovo PIN per <b>{storeName}</b>: evita sequenze (123456) o cifre ripetute.</p>
      </div>
      <div className="space-y-1.5">
        <Label className="flex items-center gap-1.5"><KeyRound className="h-3.5 w-3.5" /> Nuovo PIN (6-8 cifre)</Label>
        <Input data-testid="new-pin-input" type="password" inputMode="numeric" maxLength={8} value={pin1} onChange={(e) => setPin1(e.target.value.replace(/\D/g, ""))} className="text-center text-xl tracking-[0.4em] font-mono-code" />
      </div>
      <div className="space-y-1.5">
        <Label>Ripeti il nuovo PIN</Label>
        <Input data-testid="new-pin-confirm-input" type="password" inputMode="numeric" maxLength={8} value={pin2} onChange={(e) => setPin2(e.target.value.replace(/\D/g, ""))}
          onKeyDown={(e) => e.key === "Enter" && submit()} className={`text-center text-xl tracking-[0.4em] font-mono-code ${pin2 && !match ? "border-red-500/60" : ""}`} />
        {pin2 && !match && <p className="text-xs text-red-400" data-testid="pin-mismatch">I PIN non coincidono o sono troppo corti</p>}
      </div>
      <Button data-testid="change-pin-submit" onClick={submit} disabled={busy || !match} className="w-full h-12 gap-2">
        <ShieldCheck className="h-4 w-4" /> {busy ? "Salvataggio…" : "Salva nuovo PIN e continua"}
      </Button>
    </div>
  );
}
